const HomePage = {
  path: "/home",
  name: "huangShanHomePage",
  meta: {
    noCheckLogin: true
  },
  component: () => import("@/pages/huangshan/homePage")
};
const huangshanRoutes = [
  HomePage,
];

export default huangshanRoutes;



// WEBPACK FOOTER //
// ./src/router/huangshan.js